import React from "react";
import './skills.css'
import { skills } from "../../data/profile";


const Skills = () => {
    return(
        <section id="skills">
            <div className="container">
                <span className="section__eyebrow">Toolbox</span>
                <h2 className="section__title">Skills</h2>

                <div className="skills__container">
                    {skills.map(({ category, items }) => (
                        <article key={category} className="skills reveal">
                            <h3>{category}</h3>
                            <ul className="skills__list">
                                {items.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Skills
